export default __webpack_public_path__ + "static/media/home.2efe5724.mp4";